import { Edit, SimpleForm } from "react-admin";

import { EditToolbar } from "../../common/EditToolbar";
import { RightHolderSimpleFormContent } from "./components/RightHolderSimpleFormContent";
import { EditHeader } from "../../utils/header";

export function RightHolderEdit(): JSX.Element {
    return (
        <Edit mutationMode="pessimistic" title={<EditHeader field="name" />}>
            <SimpleForm toolbar={<EditToolbar />}>
                <RightHolderSimpleFormContent />
            </SimpleForm>
        </Edit>
    );
}
